import { SubmitButton as SubmitButtonType } from '@/schemas/sceneDataSchema';
import { ComponentButton } from './ComponentButton';

export const SubmitButton = ({ component }: { component: SubmitButtonType }) => {
  return (
    <ComponentButton
      form={component.form_id}
      component={component}
      type='submit'
    />
  );
};
